let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fVvF0")).then(() => parcelRequire('ll0df'));